<template>
    <div class="stepsdemo-content">
        <Card>
            <template v-slot:title>
                {{$t('Cobertura')}}
            </template>
            <template v-slot:subtitle>
                {{$t('solicitada')}}
            </template>
            <template v-slot:content>
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-12">
						<DataTable :value="descripciones" class="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-responsive p-datatable-customers"
								:rows="5" dataKey="id" :rowHover="true" v-model:selection="selectedCustomers" :filters="filters">
							<Column :header="$t('Descripción')">
								<template #body="slotProps">
									<div v-if="i18n.locale() == 'es'">{{slotProps.data.titulo.nombre}}</div>
									<div v-if="i18n.locale() == 'en'">{{slotProps.data.titulo.name}}</div>
								</template>
							</Column>
							<Column :header="$t('Valor')">
								<template #body="slotProps">
									{{slotProps.data.valor}}
								</template>
							</Column>
							<Column>
								<template #body="slotProps">
									<Button icon="pi pi-trash" class="p-button-rounded p-button-danger" @click="Delete(slotProps.data)"/>
								</template>
							</Column>
						</DataTable>
                        <small v-show="validationErrors.descripciones && submitted" class="p-error">{{$t('required')}}</small>
					</div>
					<div class="p-field p-col-4 p-md-2" v-if="!Dialog">
						<Button :label="$t('Agregar')" icon="pi pi-plus-circle" class="p-button-secondary"  @click="Dialog = true"/>
					</div>
                    <div class="p-field p-col-12 p-md-12" v-if="formData.datos.tipopoliza.code==5">
						<DataTable :value="inventario" class="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-responsive p-datatable-customers"
								:rows="5" dataKey="id" :rowHover="true" v-model:selection="selectedCustomers" :filters="filters">
							<Column :header="$t('Inventario')">
								<template #body="slotProps">
                                    <InputText v-model="slotProps.data.titulo" type="text"/>
								</template>
							</Column>
							<Column :header="$t('Valor')">
								<template #body="slotProps">
                                    <InputText v-model="slotProps.data.valor" type="number" style="max-width:100px;"/>
								</template>
							</Column>
							<Column>
								<template #body="slotProps">
									<Button icon="pi pi-trash" class="p-button-rounded p-button-danger" @click="DeleteInventario(slotProps.data)"/>
								</template>
							</Column>
						</DataTable>
                        <small v-show="validationErrors.descripciones && submitted" class="p-error">{{$t('required')}}</small>
					</div>
					<div class="p-field p-col-4 p-md-2" v-if="formData.datos.tipopoliza.code==5">
						<Button :label="$t('Agregar')" icon="pi pi-plus-circle" class="p-button-secondary"  @click="AgregarInventario"/>
					</div>
                </div>
            </template>
            <template v-slot:footer>
                <div class="p-grid p-nogutter p-justify-between">
                    <Button :label="$t('Anterior')" @click="prevPage()" icon="pi pi-angle-left" />
                    <Button :label="$t('Siguiente')" @click="nextPage()" icon="pi pi-angle-right" iconPos="right" />
                </div>
            </template>
        </Card>
        <Dialog v-model:visible="Dialog" :style="{width: size}" :header="$t('Valor de Propiedad')" :modal="true" :maximizable="true"> 
            <br>
            {{$t('De acuerdo al valor del Avalúo')}}
            <div class="confirmation-content">
                <div class="p-fluid p-formgrid p-grid">
					<div class="p-field p-col-12">
						<label>{{$t('Descripción')}}</label>
						<Dropdown id="state" v-model="descripcion.titulo" :options="opciones" :optionLabel="$t('nombre')" :placeholder="$t('Seleccione...')"></Dropdown>
                        <small v-show="validationErrors.titulo" class="p-error">{{$t('required')}}</small>
					</div>
					<div class="p-field p-col-6">
						<label>{{$t('Avalúo')}}</label>
                        <InputNumber id="horizontal" v-model="descripcion.valor" showButtons buttonLayout="horizontal" 
                            decrementButtonClass="p-button-danger" incrementButtonClass="p-button-success" incrementButtonIcon="pi pi-plus" 
                            decrementButtonIcon="pi pi-minus" min="0" mode="currency" :currency="$store.state.currency" />
                        <small v-show="validationErrors.valor" class="p-error">{{$t('required')}}</small>
					</div>
                </div>
            </div>
            <template #footer>
                <Button :label="$t('Agregar')" icon="pi pi-plus-circle" class="p-button-secondary" @click="Agregar" />
                <Button :label="$t('Cancelar')" icon="pi pi-times" class="p-button-danger" @click="Dialog = false"/>
            </template>
        </Dialog>
    </div>
</template>

<script>
import API from "@/service/ApiConsulta";
import { useI18nPlugin } from '@unify/vuex-i18n';
import url from "@/service/_URL";

export default {
    props: {
        formData: Object
    },
    data () {
        return {
			submitted: false,
            validationErrors: {},
			opciones: [],
			Dialog: false,
			inventario: [],
			descripciones: [],
			descripcion: {
				titulo: null,
				valor: 0,
			},
            size: '40vw',
			url: null,
			contador: 0,
        }
    },
	created() {
        this.$store.commit('Loading');
		this.contador = 0;
		this.url = url;
        this.opciones = [];
        if (this.$store.state.mobile){this.size = '80vw';}
		this.i18n = useI18nPlugin();
        const Consulta = new API('Cotizacions');
		Consulta.Ini('Aviation').then(result => {
			//this.$store.state.error = result.consult;	
			this.opciones = result.consult.opcion1;
            this.$store.commit('Loading');
		});
	},
    methods: {
		Agregar() {
            if (this.validateForm2()) {
				this.$store.commit('Loading');
				this.descripciones.push(this.descripcion);
				this.Dialog = false;
				this.descripcion = {
					titulo: null,
					valor: 0,
				};

				this.$store.commit('Loading');
            }
		},
		AgregarInventario() {
			this.inventario.push({titulo:  '', valor: 0});
		},
		Delete(selec) {
			this.descripciones = this.descripciones.filter(val => val !== selec);
		},
		DeleteInventario(selec) {
			this.inventario = this.inventario.filter(val => val !== selec);
		},
        nextPage() {
            this.submitted = true;
            if (this.validateForm() ) {
                this.$emit('next-page', {formData: {descripciones: this.descripciones, inventario: this.inventario}, pageIndex: 2});
            }
        },
        prevPage() {
            this.$emit('prev-page', {pageIndex: 2});
        },
        validateForm() {
            if (this.descripciones.length==0)
               this.validationErrors['descripciones'] = true;
            else
               delete this.validationErrors['descripciones'];
            return !Object.keys(this.validationErrors).length;
        },
        validateForm2() {
            if (this.descripcion.titulo==null)
               this.validationErrors['titulo'] = true;
            else
               delete this.validationErrors['titulo'];
            if (!this.descripcion.valor)
               this.validationErrors['valor'] = true;
            else
               delete this.validationErrors['valor'];
            return !Object.keys(this.validationErrors).length;
        },
        convfech(fecha){
            return fecha.replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1');
		},
    }
}
</script>